import React, { forwardRef } from 'react';

import { Button, LinearProgress } from '@mui/material';

import { IPrimaryButtonProps } from 'src/components/common/types/buttonTypes';

export const RED_COLOR_SX = {
	backgroundColor: '#BE3327',
	'&:hover': {
		backgroundColor: '#A52D23',
	},
};

export const PrimaryButton = forwardRef<HTMLButtonElement, IPrimaryButtonProps>(
	({ children, isLoading = false, sx, ...props }, ref) => {
		return (
			<Button
				ref={ref}
				color='primary'
				type='submit'
				variant='contained'
				disabled={isLoading}
				sx={{
					backgroundColor: '#000000B2',
					position: 'relative',
					overflow: 'hidden',
					'&:hover': {
						backgroundColor: '#000000B2',
					},
					...sx,
				}}
				fullWidth
				size='large'
				{...props}
			>
				{children}
				{isLoading && (
					<LinearProgress
						sx={{
							position: 'absolute',
							bottom: 0,
							left: 0,
							width: '100%',
							height: '2px',
							backgroundColor: '#BE3327',
							'& .MuiLinearProgress-bar': {
								backgroundColor: 'white',
							},
						}}
					/>
				)}
			</Button>
		);
	},
);

PrimaryButton.displayName = 'PrimaryButton';
